import { render, staticRenderFns } from "./ConsistencyChart.vue?vue&type=template&id=3164c9f6&scoped=true"
import script from "./ConsistencyChart.vue?vue&type=script&lang=js"
export * from "./ConsistencyChart.vue?vue&type=script&lang=js"
import style0 from "./ConsistencyChart.vue?vue&type=style&index=0&id=3164c9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164c9f6",
  null
  
)

export default component.exports